export default __webpack_public_path__ + "static/media/no-data.f1346f8b.svg";